// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fT45","textarea":"styles_textarea__2YIak"};